<template>
    <div
        class="recommendation padded-page"
        :class="{
            'rank-1': rank === 1,
            'rank-2': rank === 2,
            'rank-3': rank === 3,
            'rank-4': rank === 4,
            'rank-5': rank === 5,
            'rank-6': rank === 6,
            'rank-7': rank === 7,
        }"
    >
        <div class="mb-5 text-white font-satoshi_r max-w-xs">
            <p class="text-lg">You are</p>
            <p class="text-4xl font-satoshi_b font-bold my-2">{{ recommendations.title }}</p>
            <p class="font-satoshi_m mb-4">{{ recommendations.subTitle }}</p>
            <p>{{ recommendations.description }}</p>
        </div>
        <button class="rec-btn font-satoshi_m" @click="open">
            Read recommendation
            <img src="../../assets/images/year-in-review/ArrowUpRight.svg" alt="" />
        </button>
        <vue-bottom-sheet-vue2 ref="myBottomSheet" custom-class="custom-style">
            <p class="font-satoshi_m text-gray07 py-5">
                <span class="font-satoshi_b">{{ recommendations.title }}</span> - {{ recommendations.subTitle }}
            </p>
            <p class="font-satoshi_m text-sm text-yInRev-gray leading-6">{{ recommendations.recommendation }}</p>
            <button id="okay" class="w-full py-3 text-white rounded-xl mt-6" @click="close">Okay</button>
        </vue-bottom-sheet-vue2>
    </div>
</template>

<script>
import VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";

export default {
    components: {
        VueBottomSheetVue2,
    },

    props: {
        reviewData: Object,
    },

    data() {
        return {
            loading: false,
        };
    },

    methods: {
        getRank() {
            const {
                total_savings,
                total_outgoing_transfers,
                total_deposits,
                total_pyi,
                total_edi,
                total_cp,
                currency_conversion_count,
                has_more_than_two_due_schedules,
            } = this.reviewData;

            const totalInvestments = total_pyi + total_edi + total_cp;
            const allTotals = total_savings + totalInvestments + total_deposits + total_outgoing_transfers;

            const matches = [];

            if (totalInvestments > 1000000 && totalInvestments > total_savings) matches.push(1);
            if (totalInvestments > 1000000 && total_savings > 1000000) matches.push(2);
            if (currency_conversion_count > 0 || total_edi > 0) matches.push(3);
            if (total_savings > 1000000) matches.push(4);
            if (total_savings < total_outgoing_transfers) matches.push(5);
            if (has_more_than_two_due_schedules === true) matches.push(6);
            if (allTotals < 1000) matches.push(7);

            if (!matches.length) return 7;
            return Math.min(...matches);
        },

        open() {
            this.$refs.myBottomSheet.open();
        },
        close() {
            this.$refs.myBottomSheet.close();
        },
    },

    computed: {
        rank() {
            return this.getRank();
        },

        recommendations() {
            const map = {
                1: {
                    title: "Odogwu Pararan",
                    subTitle: "The Investment Pro",
                    recommendation:
                        "You are a true investment pro, and you've built a powerful portfolio. Your strategy is working! It's time to explore ways to diversify and maximize those returns. Let's conquer new financial heights.",
                    description:
                        "Odogwu! You're not just saving, you're building. You've moved beyond just keeping money and are now in the business of multiplying it. You see the big picture!",
                },
                2: {
                    title: "Odogwu Silencer",
                    subTitle: "The Financial Powerhouse",
                    recommendation:
                        "You’ve set the standard! The only person to beat now is yourself. Challenge yourself to new records, bigger investments – let's keep this momentum going!",
                    description:
                        "Wise and balanced, moving like a silent Odogwu. You're the true Jagaban, mastering all parts of your finances—savings, investments. A full package!",
                },
                3: {
                    title: "Idan Global",
                    subTitle: "The Cross-Border Boss",
                    recommendation:
                        "You’ve conquered the local market, and now you’re playing in the big leagues. Keep your currency game strong. Diversifying your funds is the smartest move against 'sapa' (being broke).",
                    description:
                        "Local champion ke? God forbid! You are Idan Global. You don't just speak Naira; you speak Dollars, Pounds, and Euros. Your levels have changed!",
                },
                4: {
                    title: "Akagum",
                    subTitle: "The Savings Pro",
                    recommendation:
                        "You've mastered saving! Oya, it's time to make that money work for you. Ready to unleash your investment power? Let's help you multiply that wealth.",
                    description:
                        "Ah! They say Akagum like it's a bad thing? No way! You are a savings force, a true \"hand-don-gum-money\" champion. You're a roaring success and we're super proud!",
                },
                5: {
                    title: "Agba Baller",
                    subTitle: "The Chop Life Gang",
                    recommendation:
                        "Enjoyment is key, but even a baller needs a solid game plan. A small part of that 'flex' money, saved or invested, will make sure the enjoyment lasts forever. Let's secure the bag for tomorrow!",
                    description: "Omo! You are a true baller. You dey enjoy life to the fullest, and why not? Living in the moment is the real deal.",
                },
                6: {
                    title: "True Hustler",
                    subTitle: "The Comeback Star",
                    recommendation:
                        "Life is not easy, we understand. Let's get you back on track. We dey your back! Let's clear this up and start fresh.",
                    description:
                        "My G! This hustle is real, and sometimes 'gbas gbos' (trouble/challenges) happens. But a true hustler always finds a way back.",
                },
                7: {
                    title: "The Ghost",
                    subTitle: "The Silent Observer",
                    recommendation:
                        "Time to materialize! Stop ghosting your financial goals. Come out of the shadows and make your first move—save, invest, or transact. We promise we don't bite!",
                    description:
                        "Activated. You’ve been hanging around, watching from the shadows, but we haven't seen you in action yet! We know you're there, even if you dey do like spirit.",
                },
            };

            return map[this.rank];
        },
    },
};
</script>

<style scoped>
.recommendation {
    color: #fcfcde;
    min-height: 100vh;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom;
}

.rank-1 {
    background-color: #1141bf;
    background-image: url("../../assets/images/year-in-review/recommendation-4.svg");
}

.rank-1 #okay {
    background-color: #1141bf;
}

.rank-2 {
    background-color: #ffa031;
    background-image: url("../../assets/images/year-in-review/recommendation-3.svg");
}

.rank-2 #okay {
    background-color: #ffa031;
}

.rank-3 {
    background-color: #26c165;
    background-image: url("../../assets/images/year-in-review/recommendation-6.svg");
}

.rank-3 #okay {
    background-color: #26c165;
}

.rank-4 {
    background-color: #1986bb;
    background-image: url("../../assets/images/year-in-review/recommendation-5.svg");
}

.rank-4 #okay {
    background-color: #1986bb;
}

.rank-5 {
    background-color: #ffa031;
    background-image: url("../../assets/images/year-in-review/recommendation-1.svg");
}

.rank-5 #okay {
    background-color: #ffa031;
}

.rank-6 {
    background-color: #26c165;
    background-image: url("../../assets/images/year-in-review/recommendation-2.svg");
}

.rank-6 #okay {
    background-color: #26c165;
}

.rank-7 {
    background-color: #0c1517;
    background-image: url("../../assets/images/year-in-review/recommendation-7.svg");
    background-position: center 75%;
}

.rank-7 #okay {
    background-color: #0c1517;
}

.rec-btn {
    border: 0.5px solid #ffffff80;
    display: flex;
    gap: 5px;
    padding: 8px 16px;
    border-radius: 12px;
    font-size: 14px;
}

@media (max-height: 750px) {
    .recommendation {
        background-size: auto 45%;
    }
}
</style>
